import * as React from 'react';

import * as styles from './styles/styles.css';

export function WhereYouFindOfferText() {
  return <p className={styles['description']}>Пожалуйста, скажите, что нашли это объявление на ЦИАН</p>;
}
